<div *ngFor="let plan of planes">
	<div class="pricing-block border rounded mb-4" *ngIf="type == 'wizard' || type == 'change' || ((type == 'extend' || type == 'blocked') && planSeleccionado && plan.id == planSeleccionado.id)">
		<div class="row">
			<div class="col-lg-8">
				<h2 class="font-weight-semibold text-6 line-height-1 mb-3">Plan {{ plan.nombre }}</h2>
				<hr style="margin: 10px 0" />
				<div class="row">
					<div class="col-lg-6">
						<ul class="list list-icons list-primary mb-0">
							<li><i style="top: 2px" class="fa-solid fa-building text-color-primary"></i> {{ plan.empresas }} Empresa</li>
							<li><i style="top: 2px" class="fa-sharp fa-solid fa-file-invoice-dollar text-color-primary"></i> Hasta {{ plan.maxDte }} DTE</li>
							<li style="top: 2px"><i style="top: 2px" class="fa-solid fa-plus text-color-primary"></i> {{ plan.valorDTEAdicional }} UF x doc adicional</li>
						</ul>
					</div>
					<div class="col-lg-6">
						<ul class="list list-icons list-primary mb-0">
							<li><i style="top: 2px" class="fa-solid fa-user text-color-primary"></i> {{ plan.usuarios }} Usuarios</li>
							<li><i style="top: 2px" class="fa-solid fa-receipt text-color-primary"></i> Hasta {{ plan.maxBHE }} BHE</li>
							<li class="mb-lg-0"><i style="top: 2px" class="fa-duotone fa-phone-volume text-color-primary"></i> {{ plan.soporte }}</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="plan-price mb-4">
					<span class="price"><span class="price-unit">$</span>{{ plan.precio | number : "1.0-2" : "es" }} <span class="price-unit">+ IVA</span></span>
					<label class="price-label">MENSUALES</label>
				</div>
				<div *ngIf="type != 'extend' && type != 'change' && type != 'blocked'">
					<!-- Botón 'Seleccionar' -->
					<a [id]="'plan_' + plan.nombre" *ngIf="(planSeleccionado && plan.id != planSeleccionado.id) || !planSeleccionado || planSeleccionado == undefined" class="btn btn-primary btn-modern btn-lg" [ngClass]="{ 'disabled-link': planUsuario && planUsuario.pagado && !planUsuario.activo && type == 'wizard' && !user.isPartner }" (click)="planUsuario && planUsuario.pagado && !planUsuario.activo && type == 'wizard' && !user.isPartner ? null : updatePlan(plan)"> Seleccionar </a>
					<!-- Botón 'Pagado' -->
					<div [id]="'plan_' + plan.nombre" *ngIf="planSeleccionado && plan.id == planSeleccionado.id && planUsuario && planUsuario.pagado && !planUsuario.activo && !user.isPartner" class="btn btn-success btn-modern btn-lg">Pagado</div>
					<!-- Botón 'Seleccionado' -->
					<div [id]="'plan_' + plan.nombre" *ngIf="planSeleccionado && plan.id == planSeleccionado.id && !(planUsuario && planUsuario.pagado && !planUsuario.activo && !user.isPartner)" class="btn btn-success btn-modern btn-lg">Seleccionado</div>
				</div>

				<div *ngIf="type == 'change' && planSeleccionado && planOriginal">
					<!-- Botón 'Seleccionar' -->
					<a [id]="'plan_' + plan.nombre" *ngIf="(planSeleccionado && plan.id != planOriginal.id && planSeleccionado && plan.id != planSeleccionado.id) || !planSeleccionado || planSeleccionado == undefined" class="btn btn-primary btn-modern btn-lg" (click)="updatePlan(plan)"> Seleccionar </a>

					<!-- Botón 'Seleccionado' -->
					<div [id]="'plan_' + plan.nombre" *ngIf="planSeleccionado && plan.id == planSeleccionado.id && plan.id != planOriginal.id" class="btn btn-success btn-modern btn-lg">Seleccionado</div>

					<!-- Botón 'Seleccionado' && change -->
					<div [id]="'plan_' + plan.nombre" *ngIf="planSeleccionado && plan.id == planOriginal.id" class="btn btn-warning btn-modern btn-lg disabled-link">Plan Actual</div>
				</div>
				<!-- Botón 'Extender' -->
				<div [id]="'plan_' + plan.nombre" *ngIf="(type == 'extend' || type == 'blocked') && planSeleccionado && plan.id == planSeleccionado.id && planUsuario" class="btn btn-success btn-modern btn-lg">Plan Actual</div>
			</div>
		</div>
	</div>
</div>
